import { render, staticRenderFns } from "./VAccordion.vue?vue&type=template&id=ffe5e576&scoped=true"
import script from "./VAccordion.vue?vue&type=script&lang=ts"
export * from "./VAccordion.vue?vue&type=script&lang=ts"
import style0 from "./VAccordion.vue?vue&type=style&index=0&id=ffe5e576&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe5e576",
  null
  
)

export default component.exports